module.exports = __webpack_public_path__ + "media/images/staklo4d-4c907005.svg";